// extracted by mini-css-extract-plugin
export default {"btn":"SliderButton_btn__RJ8dt"};